// Social-proof video carousel — center-focused "coverflow".
// The centred (hero) card keeps full size; side cards shrink & dim. As you scroll or
// use the arrows, each card's scale is recomputed every frame from its distance to the
// carousel centre, so the incoming card grows smoothly into the hero spot.
(function () {
  const root = document.getElementById('lpProofSectionFixed');
  if (!root) return;

  const carousel = root.querySelector('.lp-proof-carousel');
  const prevBtn = root.querySelector('.lp-proof-nav--prev');
  const nextBtn = root.querySelector('.lp-proof-nav--next');
  const cards = Array.from(root.querySelectorAll('.lp-proof-card'));
  const videos = Array.from(root.querySelectorAll('.lp-proof-video'));
  if (!carousel || !cards.length) return;

  const GAP = 24;
  const SIDE_SCALE = 0.80;    // side cards shrink to 80% of the hero
  const SIDE_OPACITY = 0.50;  // …and dim to 50%
  const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---- responsive sizing: a fixed px card width + side padding so any card (incl. the
  //      first & last) can settle dead-centre under scroll-snap ----
  function layout() {
    const cw = carousel.clientWidth;
    let card;
    if (cw <= 560)      card = Math.round(cw * 0.68);
    else if (cw <= 900) card = Math.round((cw - GAP) / 2.1);
    else                card = Math.min(Math.round((cw - 2 * GAP) / 3), 400);
    card = Math.max(160, card);
    carousel.style.setProperty('--card', card + 'px');
    carousel.style.setProperty('--gap', GAP + 'px');
    const pad = Math.max(0, (cw - card) / 2);
    carousel.style.paddingLeft = pad + 'px';
    carousel.style.paddingRight = pad + 'px';
    carousel.style.scrollPaddingLeft = pad + 'px';
    carousel.style.scrollPaddingRight = pad + 'px';
    update();
  }

  // ---- live coverflow scaling ----
  let ticking = false;
  function update() {
    const r = carousel.getBoundingClientRect();
    const mid = r.left + r.width / 2;
    let active = null, best = Infinity;
    for (const card of cards) {
      const cr = card.getBoundingClientRect();
      const c = cr.left + cr.width / 2;
      const span = (cr.width || 1) + GAP;
      const t = Math.min(Math.abs(mid - c) / span, 1); // 0 at centre → 1 one card away
      const scale = reduce ? 1 : (1 - t * (1 - SIDE_SCALE));
      card.style.transform = 'scale(' + scale.toFixed(3) + ')';
      card.style.opacity = (1 - t * (1 - SIDE_OPACITY)).toFixed(3);
      card.style.zIndex = String(100 - Math.round(t * 100));
      if (t < best) { best = t; active = card; }
    }
    for (const card of cards) card.classList.toggle('is-active', card === active && best < 0.5);
    updateNav();
  }
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { update(); ticking = false; });
  }

  function getMaxScroll() { return Math.max(0, carousel.scrollWidth - carousel.clientWidth); }
  function updateNav() {
    if (!prevBtn || !nextBtn) return;
    const left = Math.round(carousel.scrollLeft);
    const max = Math.round(getMaxScroll());
    prevBtn.disabled = left <= 2;
    nextBtn.disabled = left >= max - 2;
  }
  function step() {
    const w = cards[0].getBoundingClientRect().width || 300;
    return w + GAP;
  }
  function move(dir) {
    const target = carousel.scrollLeft + (dir === 'next' ? step() : -step());
    carousel.scrollTo({ left: target, behavior: reduce ? 'auto' : 'smooth' });
  }
  if (prevBtn) prevBtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); move('prev'); });
  if (nextBtn) nextBtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); move('next'); });

  carousel.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', layout);

  // ---- lazy media: the markup ships preload="none" so a page view costs 0 video bytes.
  //      Only cards that actually come near the carousel viewport are upgraded to
  //      preload="metadata", which is what paints their first frame (our poster).
  //      Without this, N videos x metadata = tens of MB fetched above the fold.
  function primeVideo(v) {
    if (!v || v.dataset.lpPrimed) return;
    v.dataset.lpPrimed = '1';
    v.preload = 'metadata';
    try { v.load(); } catch (e) {}
  }
  // Plain geometry rather than IntersectionObserver: we need BOTH a vertical gate
  // (the section is far below the fold) and a horizontal one (only the cards inside
  // the carousel's scrollport), and one rect test covers both without depending on
  // observer/root quirks.
  function viewportH() {
    return window.innerHeight || document.documentElement.clientHeight || 0;
  }
  function primeNearby() {
    var h = viewportH();
    if (!h) return; // can't measure the viewport — leave it to the play handler
    var sec = root.getBoundingClientRect();
    if (sec.top > h + 600 || sec.bottom < -600) return;   // section not near yet
    var cr = carousel.getBoundingClientRect();
    for (var i = 0; i < cards.length; i++) {
      var r = cards[i].getBoundingClientRect();
      // one card of lead time on either side of the carousel's visible slice
      if (r.right > cr.left - 400 && r.left < cr.right + 400) {
        primeVideo(cards[i].querySelector('.lp-proof-video'));
      }
    }
  }
  var primeTick = false;
  function primeSoon() {
    if (primeTick) return;
    primeTick = true;
    requestAnimationFrame(function () { primeNearby(); primeTick = false; });
  }
  window.addEventListener('scroll', primeSoon, { passive: true });
  window.addEventListener('resize', primeSoon);
  carousel.addEventListener('scroll', primeSoon, { passive: true });
  primeSoon();
  // A user pressing play always wins, even if priming hasn't run for that card yet.
  videos.forEach(function (v) { v.addEventListener('play', function () { primeVideo(v); }); });

  // only one video plays at a time; pause everything when the tab is hidden
  function pauseOthers(cur) { videos.forEach(function (v) { if (v !== cur) v.pause(); }); }
  videos.forEach(function (v) {
    v.setAttribute('playsinline', '');
    v.setAttribute('webkit-playsinline', '');
    v.addEventListener('play', function () { pauseOthers(v); });
  });
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) videos.forEach(function (v) { v.pause(); });
  });

  // init
  layout();
  window.requestAnimationFrame(update);
  setTimeout(layout, 150);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(layout);
})();
